import { render } from "./list.vue?vue&type=template&id=4951d9a0&ts=true"
import script from "./list.vue?vue&type=script&lang=ts&config=true"
export * from "./list.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__